export enum EUserType {
  임직원 = 1,
  사내협력 = 2,
  사외협력 = 3,
  임시증 = 4,
  일반 = 5,
  상주 = 6,
  대여 = 7,
  의전 = 8,
  외교 = 9,
  순찰 = 10,
  임시 = 11,
  방문객 = 12
}
